export const MANSIONGLOBAL_COLORS = Object.freeze([
  '#2C4B72',
  '#5E8197',
  '#67A9A9',
  '#9DD7D8',
  '#B9B7B8',
  '#91BACC',
  '#9CA894',
  '#DD8979',
  'rgba(0, 0, 0, 0)',
  '#062e5e',
  '#353742',
]);

const MANSIONGLOBAL_THEME = Object.freeze({
  name: 'Mansion Global',
  theme: Object.freeze([
    MANSIONGLOBAL_COLORS[0],
    MANSIONGLOBAL_COLORS[1],
    MANSIONGLOBAL_COLORS[2],
    MANSIONGLOBAL_COLORS[3],
    MANSIONGLOBAL_COLORS[4],
    MANSIONGLOBAL_COLORS[5],
    MANSIONGLOBAL_COLORS[6],
    MANSIONGLOBAL_COLORS[7],
  ]),
});

export const MANSIONGLOBAL_PLOT_LINE_COLORS = Object.freeze([
  MANSIONGLOBAL_COLORS[0],
  MANSIONGLOBAL_COLORS[4],
]);

const MANSIONGLOBAL_BLUE_THEME = Object.freeze({
  name: 'Blue theme',
  theme: Object.freeze([MANSIONGLOBAL_COLORS[9], '#0c1235', '#445364', '#072e5e', '#0080c3']),
});

const MANSIONGLOBAL_GRAY_THEME = Object.freeze({
  name: 'Gray theme',
  theme: Object.freeze([MANSIONGLOBAL_COLORS[10], '#565b61', '#777777', '#929292', '#E5E5E5']),
});

export const MANSIONGLOBAL_COLOR_THEMES = Object.freeze({
  mansionglobal: MANSIONGLOBAL_THEME,
  mansionglobal_blue: MANSIONGLOBAL_BLUE_THEME,
  mansionglobal_gray: MANSIONGLOBAL_GRAY_THEME,
});

export const MANSIONGLOBAL_PIE_THEME = Object.freeze([
  ...MANSIONGLOBAL_BLUE_THEME.theme,
  ...MANSIONGLOBAL_GRAY_THEME.theme,
]);
